import { Configuration } from "../../model/Configuration";
import { configurationSource } from "../../model/constants/configuration";

export const getConfiguration = async (): Promise<Configuration> => {
  return (await fetch(configurationSource).then((res) => res.json())) as Configuration;
};
